const decodeJwtPayload = (token) => {
  if (!token || typeof token !== "string") return null;

  const parts = token.split(".");
  if (parts.length < 2) return null;

  try {
    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
    const json = atob(padded);
    return JSON.parse(json);
  } catch {
    return null;
  }
};

export const tokenHasUserUidClaim = (token) => {
  const payload = decodeJwtPayload(token);
  if (!payload) return false;

  const userUid = payload.user_uid ?? payload.UserUid;
  return Boolean(userUid && String(userUid).trim().length > 0);
};

export const requireRealtimeAuth = () => {
  const token = localStorage.getItem("token");
  if (!token || token === "null") return false;

  if (!tokenHasUserUidClaim(token)) {
    window.dispatchEvent(new Event("sessionExpired"));
    return false;
  }

  return true;
};
